// 设备数据
<template>
  <div class="admin">
    <div class="submit"><el-button type="primary"  @click="submitForm">保存</el-button><span class="tip">操作后务必保存，以免数据丢失</span></div>
    <el-form :model="jsonData" ref="jsonData" label-width="80px">
      <el-tabs v-model="tabActive">
        <el-tab-pane :label="item.name" :name="index+''" v-for="(item,index) in jsonData.device" :key="index">
          <el-row :gutter="10">
            <el-card class="box-card">
              <div slot="header">物理工厂设备模型详情</div>
              <el-row :gutter="10">
                <el-col :span="8" v-for="(it,i) in item.yx" :key="'yx'+i">
                  <el-form-item :label="it.name" label-width="150px">
                    <MzInput v-model.trim="it.value" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-for="(it,i) in item.sc" :key="'sc'+i">
                  <el-form-item :label="it.name" label-width="150px">
                    <MzInput v-model.trim="it.value" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8" v-if="index<14">
                  <el-form-item label="背景设备图片" label-width="150px">
                    <mzfile v-model="item.image" tip="只能上传jpg/jpeg/png文件"></mzfile>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item v-if="index<14" label="功能介绍" label-width="150px">
                    <MzInput v-model.trim="item.intro" type="textarea" :rows="4" placeholder="请输入"></MzInput>
                  </el-form-item>
                  <el-form-item label="监控视频(物理/虚拟)" label-width="150px">
                    <MzInput v-model.trim="item.jksp" placeholder="视频格式mp4"></MzInput>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
            <el-card class="box-card">
              <div slot="header">虚拟工厂设备模型详情（设备监测数据）</div>
              <el-row :gutter="10">
                <el-col :span="4" v-for="(item,index) in item.sbjc" :key="index">
                  <el-form-item :label="item.name" label-width="60px">
                    <MzInput v-model.trim="item.value" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
            <el-card class="box-card">
              <div slot="header">虚拟工厂设备模型详情（报警信息数据）</div>
              <el-row :gutter="10">
                <el-col :span="4" v-for="(item,index) in item.bjxx" :key="index">
                  <el-form-item :label="item.name" label-width="100px">
                    <MzInput v-model.trim="item.value" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>

import axios from "axios"
import mzfile from '@/components/mz_upload/index';
import mzfile2 from '@/components/mz_upload/fileUpload';
export default {
  components: {mzfile,mzfile2},
  name: '',
  data() {
    return {
      activeNames: [],
      tabActive: '0',
      fileHandle: null,
      jsonData: {device:''}
    };
  },
  created() {
    // this.jsonData = {
    //   device: [{
    //             name: '原料粉碎',
    //             intro: '原料粉碎设备主要用于处理酪蛋白生产的初始原料，通常是干酪素或相关奶原料。它通过机械研磨作用，将块状、颗粒较大的原料破碎成均匀细小的颗粒，减少后续溶解环节的阻力，提升原料与溶剂的接触面积，为后续溶解工序高效进行奠定基础，确保原料能充分溶解，避免因颗粒过大导致溶解不彻底而影响产品质量。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'加工目数（mg/kg）',value:'55'}],
    //             image: '/assets/image/gylc/原料粉碎.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '螺旋输送机',
    //             intro: '螺旋输送机是酪蛋白生产中的物料输送设备，依靠螺旋叶片的旋转推动物料移动。它能在密闭的输送管道内，将粉碎后的原料或中间物料平稳、连续地输送至下一工序，如从原料粉碎环节输送到溶解罐。其密闭设计可减少物料在输送过程中的粉尘泄漏，保证生产环境洁净，同时避免物料受潮、污染，且能适应不同生产场地布局，实现物料的水平或倾斜输送。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_zs',
    //               name: '输送速度（m/s）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'输送量（kg）',value:'55'}],
    //             image: '/assets/image/gylc/螺旋输送机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '溶解罐',
    //             intro: '溶解罐是实现原料溶解的关键设备，罐体内配备搅拌装置和加热系统。将粉碎后的原料与特定溶剂（通常是水或相关溶液）按比例投入罐中后，搅拌装置启动使物料与溶剂充分混合，加热系统则根据工艺要求控制罐内温度，为原料溶解提供适宜的温度条件，加速溶解过程，确保原料形成均匀的溶液，满足后续净乳等工序对物料状态的要求。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '溶解温度',
    //               value: '55'
    //             },{
    //               icon: 'icon_sd',
    //               name: '物料浓度（g/l）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'溶剂PH值',value:'55'},{name:'溶解率（%）',value:'55'}],
    //             image: '/assets/image/gylc/溶解罐.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '净乳机',
    //             intro: '净乳机主要用于去除原料溶液中的杂质和部分乳脂肪。它利用离心分离原理，高速旋转的转鼓产生强大离心力，使溶液中的杂质（如细小固体颗粒、灰尘等）和密度与溶液不同的乳脂肪分离出来。杂质因密度较大被甩向转鼓内壁，定期排出；乳脂肪则聚集在特定区域收集，从而得到纯净的乳清溶液，为后续生产高纯度酪蛋白提供保障。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_kl',
    //               name: '杂质去除率（%）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'处理量（m³/h）',value:'55'}],
    //             image: '/assets/image/gylc/净乳机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '缓冲罐',
    //             intro: '缓冲罐在酪蛋白生产流程中起到缓冲和稳定物料流量的作用。由于前序工序（如净乳机）和后序工序（如脱脂机）的处理速度可能存在差异，缓冲罐可暂时储存经过净乳的溶液，避免因物料供应不稳定导致后续工序中断或过载，同时也能让物料在罐内有短暂的静置时间，进一步沉淀细小杂质，保证进入脱脂机的物料质量稳定。',
    //             yx: [{
    //               icon: 'icon_zs',
    //               name: '液位波动幅度（%/h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_zs',
    //               name: '出料流量（L/min）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'物料PH值',value:'55'}],
    //             image: '/assets/image/gylc/缓冲罐.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '脱脂机',
    //             intro: '脱脂机的核心功能是进一步去除乳清溶液中残留的脂肪。它同样基于离心分离技术，但相较于净乳机，其分离精度更高。通过优化转鼓结构和转速，脱脂机能将溶液中残留的微量脂肪分离出来，使脱脂后的乳清溶液脂肪含量降至极低水平，满足酪蛋白生产对原料纯度的严格要求，防止脂肪残留影响最终酪蛋白产品的品质和保质期。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '加工温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_zs',
    //               name: '脂肪去除率（%）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'处理量（m³/h）',value:'55'}],
    //             image: '/assets/image/gylc/脱脂机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '灭菌机',
    //             intro: '灭菌机用于杀灭乳清溶液中的微生物，保障生产过程的卫生安全和产品质量。根据生产工艺不同，常见的有巴氏灭菌机和超高温瞬时灭菌机等。灭菌机通过控制温度和处理时间，有效杀灭溶液中可能存在的细菌、霉菌等有害微生物，同时尽量减少高温对乳清溶液中有效成分的破坏，确保后续凝乳等工序在无菌环境下进行，避免微生物污染导致产品变质。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '灭菌温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_zs',
    //               name: '物料流速（m³/h）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'微生物杀灭率（%）',value:'55'}],
    //             image: '/assets/image/gylc/灭菌机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '凝乳罐',
    //             intro: '凝乳罐是酪蛋白形成的关键设备，用于将经过灭菌脱脂的乳清溶液转化为凝乳。在罐内，通过添加凝乳酶或调整 pH 值等方式，使乳清中的蛋白质（主要是酪蛋白）发生凝固反应，形成絮状的凝乳。凝乳罐内设有搅拌装置，可缓慢搅拌物料，确保凝乳酶均匀分布，使凝固反应充分且均匀，形成质地均匀的凝乳块，为后续压滤工序分离乳清和凝乳做好准备。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '加工温度（℃）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'沉淀 pH 值',value:'55'}],
    //             image: '/assets/image/gylc/凝乳罐.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '压滤机',
    //             intro: '压滤机主要用于分离凝乳中的乳清，得到湿酪蛋白。它通过加压的方式，使凝乳块中的乳清通过滤布或滤板排出，而酪蛋白则被截留形成滤饼（湿酪蛋白）。压滤机可根据工艺要求调整压力和过滤时间，控制湿酪蛋白的含水量，确保后续干燥工序能高效进行，同时过滤后的乳清可回收利用，提高原料利用率，降低生产成本。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_sd',
    //               name: '脱水后含水率（%）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'处理量（kg/h）',value:'55'}],
    //             image: '/assets/image/gylc/压滤机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '湿法破碎机',
    //             intro: '湿法破碎机用于处理压滤后的湿酪蛋白滤饼。由于压滤后的湿酪蛋白可能形成较大的块状或团状结构，不利于后续干燥。湿法破碎机通过机械破碎作用，将湿酪蛋白块破碎成细小、均匀的颗粒或浆状物料，增大物料的比表面积，加快后续干燥塔内水分的蒸发速度，缩短干燥时间，提高干燥效率，同时也能保证干燥后的酪蛋白颗粒均匀，提升产品质量。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_zs',
    //               name: '粒径均匀度（%）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'破碎合格率（%）',value:'55'},{name:'处理量（kg/h）',value:'55'}],
    //             image: '/assets/image/gylc/湿法破碎机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '干燥塔',
    //             intro: '干燥塔是将湿法破碎后的湿酪蛋白物料干燥成干酪蛋白粉末的核心设备，常见的有喷雾干燥塔等。湿物料通过雾化器雾化成细小的雾滴，与塔内高温热气流充分接触，雾滴中的水分在短时间内迅速蒸发，形成干燥的酪蛋白粉末。干燥塔能精确控制进风温度、出风温度和风速等参数，确保干燥后的酪蛋白粉末含水量达标，且颗粒均匀、溶解性好，满足产品质量要求。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_sd',
    //               name: '成品含水率（%）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'酪蛋白得率（%）',value:'55'}],
    //             image: '/assets/image/gylc/干燥塔.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '粉碎机组',
    //             intro: '粉碎机组用于对干燥后的酪蛋白粉末进行进一步粉碎和筛分，提升产品细度和均匀度。干燥后的酪蛋白可能存在部分结块现象，粉碎机组中的粉碎机先将结块破碎，随后通过筛分设备筛选出粒度符合要求的粉末，粒度不达标的粗粉则返回粉碎机再次粉碎。通过这一过程，使最终的酪蛋白粉末粒度均匀一致，满足不同应用场景对产品细度的需求，提升产品市场竞争力。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_kl',
    //               name: '粒径均匀度（%）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg）',value:'55'},{name:'成品目数',value:'55'},{name:'物料损耗率（%）',value:'55'}],
    //             image: '/assets/image/gylc/粉碎机组.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '混料机',
    //             intro: '混料机主要用于对粉碎后的酪蛋白粉末进行混合，确保产品质量均匀，或根据配方添加其他辅料。在酪蛋白生产的后期，若需要调整产品成分（如添加稳定剂、营养强化剂等），混料机可将酪蛋白粉末与辅料按比例充分混合，使各成分均匀分布在产品中，避免出现局部成分过高或过低的情况。同时，即使不添加辅料，混料机也能对不同批次的酪蛋白粉末进行混合，保证产品质量的一致性。',
    //             yx: [{
    //               icon: 'icon_sc',
    //               name: '加工时长（h）',
    //               value: '55'
    //             },{
    //               icon: 'icon_zs',
    //               name: '混合均匀度（CV值/%）',
    //               value: '55'
    //             }],
    //             sc: [{name:'设备加工量（kg',value:'55'},{name:'成分含量偏差（%）',value:'55'},{name:'物料结块率（%）',value:'55'}],
    //             image: '/assets/image/gylc/混料机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '自动包装机',
    //             intro: '自动包装机用于对最终的酪蛋白粉末进行自动化包装，提高包装效率和包装质量。它能根据设定的包装规格（如袋式、瓶装等），自动完成物料计量、填充、封口、贴标等一系列操作。自动包装机计量精度高，可有效控制每包产品的重量误差，同时包装速度快，能满足大规模生产的需求。其自动化操作还能减少人工接触，降低产品污染风险，且包装密封性能好，可延长酪蛋白产品的保质期，便于产品储存和运输。',
    //             yx: [{
    //               icon: 'icon_zs',
    //               name: '包装速率（件/分钟）',
    //               value: '55'
    //             },{
    //               icon: 'icon_sd',
    //               name: '密封性（%/24h）',
    //               value: '55'
    //             }],
    //             sc: [{name:'包装量（kg）',value:'55'},{name:'单件重量（kg）',value:'55'},{name:'合格率',value:'55'}],
    //             image: '/assets/image/gylc/自动包装机.jpg',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '除尘器',
    //             intro: '',
    //             yx: [],
    //             sc: [],
    //             image: '',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '储气罐',
    //             intro: '',
    //             yx: [],
    //             sc: [],
    //             image: '',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '空压机',
    //             intro: '',
    //             yx: [],
    //             sc: [],
    //             image: '',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         },{
    //             name: '冷干机',
    //             intro: '',
    //             yx: [],
    //             sc: [],
    //             image: '',
    //             jksp: '',
    //             sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //             bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //         }]
    // }
    this.getData('device')
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          this.jsonData = res.data.data
        }
      })
    },
    saveData(name){
      let params = {
        fileName: name,
        fileData: this.jsonData
      }
      axios.post(this.$baseUrl+'/api/web/file/data/save',params).then(res => {
        if(res.data.code === 200){
          this.$message({
            message: res.data.msg,
            type: 'success',
            customClass: 'adminMsg'
          });
          this.getData('device')
        }else{
          this.$message({
            message: res.data.msg,
            type: 'error',
            customClass: 'adminMsg'
          });
        }
      })
    },
    updateData(type,btn,index){
      if(btn==='add'){
        if(type==='jqg'){
          this.jsonData.jqg.push({name:'',imageUrl:'',videoUrl:''})
        }else if(type==='jsln'){
          this.jsonData.jsln.push({url:''})
        }
      }
      if(btn==='del'){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type==='jqg'){
            this.jsonData.jqg.splice(index,1)
          }else if(type==='jsln'){
            this.jsonData.jsln.splice(index,1)
          }
        }).catch(() => {
          console.log("已取消")         
        });
      }
    },
    submitForm(){
      this.$confirm('此操作将覆盖原有数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.initFile()
        this.saveData('device')
      }).catch(() => {
        console.log("已取消")         
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/admin';
</style>